module.exports = __webpack_public_path__ + "img/lb.cd47c8f4.svg";